// extracted by mini-css-extract-plugin
export default {"header":"classes_header__piZGb","icon":"classes_icon__AoJOf"};